/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from './totalAmount/totalAmount.component.ngfactory';
import * as i2 from '../../../../app/components/reports/totalAmount/totalAmount.component';
import * as i3 from '../../../../app/services/reportService';
import * as i4 from '@angular/router';
import * as i5 from '../../../../app/common/managers/storageManager';
import * as i6 from '../../../../app/services/configService';
import * as i7 from '../../../../app/components/reports/totalFeeReport.component';
const styles_TotalFeeReportComponent:any[] = ([] as any[]);
export const RenderType_TotalFeeReportComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_TotalFeeReportComponent,data:{}});
export function View_TotalFeeReportComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'report-total-fee',
      ([] as any[]),(null as any),(null as any),(null as any),i1.View_TotalAmountComponent_0,
      i1.RenderType_TotalAmountComponent)),i0.ɵdid(114688,(null as any),0,i2.TotalAmountComponent,
      [i3.ReportService,i4.ActivatedRoute,i5.StorageManager,i6.ConfigService],{reportType:[0,
          'reportType']},(null as any))],(_ck,_v) => {
    var _co:i7.TotalFeeReportComponent = _v.component;
    const currVal_0:any = _co.reportType.TotalFee;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_TotalFeeReportComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'report-total-fee-container',
      ([] as any[]),(null as any),(null as any),(null as any),View_TotalFeeReportComponent_0,
      RenderType_TotalFeeReportComponent)),i0.ɵdid(49152,(null as any),0,i7.TotalFeeReportComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const TotalFeeReportComponentNgFactory:i0.ComponentFactory<i7.TotalFeeReportComponent> = i0.ɵccf('report-total-fee-container',
    i7.TotalFeeReportComponent,View_TotalFeeReportComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy90b3RhbEZlZVJlcG9ydC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy90b3RhbEZlZVJlcG9ydC5jb21wb25lbnQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9yZXBvcnRzL3RvdGFsRmVlUmVwb3J0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy90b3RhbEZlZVJlcG9ydC5jb21wb25lbnQudHMuVG90YWxGZWVSZXBvcnRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8cmVwb3J0LXRvdGFsLWZlZSBbcmVwb3J0VHlwZV09XCJyZXBvcnRUeXBlLlRvdGFsRmVlXCI+PC9yZXBvcnQtdG90YWwtZmVlPiIsIjxyZXBvcnQtdG90YWwtZmVlLWNvbnRhaW5lcj48L3JlcG9ydC10b3RhbC1mZWUtY29udGFpbmVyPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7d0NBQUEsVUFBQTtNQUFBO1VBQUE7O0lBQWtCO0lBQWxCLFdBQWtCLFNBQWxCOzs7O29CQ0FBO01BQUE7d0NBQUEsVUFBQTtNQUFBOzs7In0=



// WEBPACK FOOTER //
// ./compiled/app/components/reports/totalFeeReport.component.ngfactory.ts